import { Fragment } from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { FPActionButton, When } from 'UI/components/atoms';
import ProfileRecruitersView from 'UI/components/organisms/inventoryProfiles/ProfileRecruitersView';

import { useStyles } from './ProfileAccountableBar.styled';

/**
 * @typedef {import('features/inventory-profiles/hooks/useProfileAccountability').ProfileAccountability} ProfileAccountability
 */

/**
 * Accountable and team band under the profile summary. It is identical in the five entities,
 * so it is one component and the containers only pass what useProfileAccountability returns.
 * Renders nothing when there is no recruiter and no free-game action to show.
 * @param {Object} props
 * @param {Pick<ProfileAccountability, 'isVisible' | 'recruiterViews' | 'freeGameAction' | 'onReassignClick'>} props.assignment
 *   Return value of useProfileAccountability (only these fields are read)
 */
export const ProfileAccountableBar = ({ assignment }) => {
  const classes = useStyles();

  if (!assignment.isVisible) return null;

  return (
    <div className={classes.barContainer}>
      <Grid alignItems="center" container justifyContent="flex-start" spacing={1}>
        {assignment.recruiterViews.map((view, index) => (
          <Fragment key={view.key}>
            <When condition={index > 0}>
              <Grid item>
                <Divider className={classes.recruiterDivider} orientation="vertical" />
              </Grid>
            </When>
            <Grid item>
              <ProfileRecruitersView
                assistant={view.assistant}
                coach={view.coach}
                isReassignButtonVisible={view.isReassignButtonVisible}
                onReassignClick={assignment.onReassignClick}
                recruiter={view.recruiter}
              />
            </Grid>
          </Fragment>
        ))}
        <When condition={assignment.freeGameAction.isVisible}>
          <Grid item>
            <FPActionButton
              iconPosition="none"
              onClick={assignment.onReassignClick}
              size="small"
              text={assignment.freeGameAction.label}
              type="button"
              variant="outlined"
            />
          </Grid>
        </When>
      </Grid>
    </div>
  );
};
